<template>
  <v-row v-if="attributes.length">
    <v-col cols="12">
      <div class="title">
        Product Attributes
      </div>
    </v-col>

    <template v-for="attr in attributes">
      <v-col
        v-if="!isHideInput(attr.id)"
        :key="attr.id"
        cols="12"
        md="6"
      >
        <div class="mb-1">
          {{ attr.label || attr.name }}
          <v-icon
            v-if="attr.advanced && attr.advanced.isKeyProp === 1"
            small
            color="primary"
            title="Key Property">
            mdi-key
          </v-icon>
          <span
            v-if="attr.isMandatory"
            class="red--text">*</span>
        </div>

        <v-combobox
          v-if="['enumInput', 'multiEnumInput'].includes(attr.inputType)"
          v-model="localData[attr.name]"
          :items="attr.options || []"
          :multiple="attr.inputType === 'multiEnumInput'"
          :chips="attr.inputType === 'multiEnumInput'"
          :label="attr.label || attr.name"
          item-text="name"
          item-value="name"
          :rules="getRules(attr)"
          :return-object="false"
          small-chips
          outlined
          dense
          hide-details="auto"
          :disabled="loading || disabled"
        />

        <v-autocomplete
          v-else-if="['singleSelect', 'multiSelect'].includes(attr.inputType)"
          v-model="localData[attr.name]"
          :items="attr.options || []"
          :multiple="attr.inputType === 'multiSelect'"
          :chips="attr.inputType === 'multiSelect'"
          :label="attr.label || attr.name"
          item-text="name"
          item-value="name"
          :rules="getRules(attr)"
          :return-object="false"
          small-chips
          outlined
          dense
          hide-details="auto"
          :disabled="loading || disabled"
        />

        <v-textarea
          v-else-if="attr.inputType === 'richText'"
          v-model="localData[attr.name]"
          :label="attr.label || attr.name"
          :rules="getRules(attr)"
          outlined
          rows="3"
          hide-details="auto"
          :disabled="loading || disabled"
        />

        <v-text-field
          v-else-if="attr.inputType === 'date'"
          v-model="localData[attr.name]"
          type="date"
          :label="attr.label || attr.name"
          :rules="getRules(attr)"
          outlined
          dense
          hide-details="auto"
          :disabled="loading || disabled"
        />

        <v-file-input
          v-else-if="attr.inputType === 'img'"
          v-model="localData[attr.name]"
          :label="attr.label || attr.name"
          :rules="getRules(attr)"
          prepend-icon=""
          prepend-inner-icon="mdi-camera"
          outlined
          dense
          hide-details="auto"
          :disabled="loading || disabled"
        />

        <v-text-field
          v-else
          v-model="localData[attr.name]"
          :label="attr.label || attr.name"
          :type="attr.inputType === 'numeric' ? 'number' : 'text'"
          :rules="getRules(attr)"
          outlined
          dense
          hide-details="auto"
          :disabled="loading || disabled"
        />
      </v-col>
    </template>

    <v-col
      v-if="!attributes.length"
      cols="12">
      No attributes found. Please select a category first.
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    // Expects an Object now: { material: "Cotton", description: "..." }
    value: {
      type: Object,
      default: () => ({})
    },
    // The JSON structure provided
    attributes: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      rules: {
        required: [
          (v) => (Array.isArray(v) ? v.length > 0 : !!v) || 'This field is required.'
        ],
        number: [
          (v) => !!v || 'This field is required.',
          // (v) => /^[+-]?([0-9]*[.])?[0-9]+$/.test(v) || 'This field must be valid number.',
          (v) => /^[+-]?\d+$/.test(v) || 'This field must be valid number.',
          (v) => v > 0 || 'This field must be positive number.'
        ],
        minLength: (length = 25) => ([
          (v) => (!!v && v.length >= length) || `This field must be at least ${length} characters`
        ]),
        maxLength: (length = 255) => ([
          (v) => (!!v && v.length <= length) || `This field must be at most ${length} characters`
        ])
      }
    }
  },
  computed: {
    // Proxy for v-model to handle Object updates cleanly
    localData: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    isHideInput (id) {
      // Logic from original snippet
      return id === 100000 || id === 100007 // Changed strings to numbers to match JSON ID type
    },
    getRules (attr) {
      if (attr.isMandatory && attr.inputType === 'numeric') {
        return this.rules.number
      }

      if (attr.isMandatory) {
        return this.rules.required
      }

      return []
    }
  }
}
</script>
